import { cn } from "@/lib/utils";
import { useTranslations } from "use-intl";
import { ThreadStatusFilter } from "@/gql/graphql";

const OPTIONS = [
  { value: ThreadStatusFilter.Open, label: "open" },
  { value: ThreadStatusFilter.Closed, label: "closed" },
] as const;

export function ThreadStatusPills({
  status,
  onStatusChange,
  unreadCounts,
}: {
  status: ThreadStatusFilter;
  onStatusChange: (status: ThreadStatusFilter) => void;
  unreadCounts?: Partial<Record<ThreadStatusFilter, number>>;
}) {
  const t = useTranslations("thread.status");

  return (
    <div className="flex gap-1 rounded-lg bg-gray-100 p-1">
      {OPTIONS.map((option) => {
        const isSelected = option.value === status;
        const unreadCount = unreadCounts?.[option.value];

        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={isSelected}
            onClick={() => onStatusChange(option.value)}
            className={cn(
              "flex flex-1 items-center justify-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
              isSelected
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-500 hover:text-gray-700",
            )}
          >
            {t(option.label)}
            {unreadCount ? (
              <span className="rounded-full bg-indigo-500 px-1.5 text-xs font-semibold text-white">
                {unreadCount > 99 ? "99+" : unreadCount}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
